/* === Mengenfelder: Schrift passt sich der Stellenzahl an ===
   Das Feld zwischen − und + ist schmal. Eine 1 passt bequem, eine 12 gerade so, ab drei
   Stellen wird der Wert abgeschnitten. Die Schrift soll deshalb mit jeder weiteren
   Stelle etwas kleiner werden.

   In reinem CSS geht das nicht: Ein Selektor kann nicht zaehlen, wie viele Zeichen in
   einem Feld stehen. Dieses Skript schreibt die Laenge deshalb als data-qty-len an das
   Feld, und assets/mobile.css leitet daraus die Schriftgroesse ab. Die Gestaltung
   bleibt damit im CSS — hier steht nur die Zahl.

   Warum Ereignis-Delegation und ein Beobachter: Nach jeder Mengenaenderung tauscht
   Shopify den kompletten Warenkorb-Abschnitt aus (cart.js). Direkt gebundene Handler
   waeren danach verloren, und die frisch eingefuegten Felder haetten kein Attribut. */
(() => {
  // Beide Mengenfelder des Shops: das im Warenkorb und das in der Kaufbox der
  // Produktseite. Die Datei heisst weiterhin cart-qty-fit.js, weil sie aus dem Warenkorb
  // stammt und dort ueber diesen Namen eingebunden ist — sie gilt inzwischen aber fuer
  // beide Stellen. Die Groessen selbst stehen in assets/mobile.css, je Ort getrennt:
  // Die Felder sind unterschiedlich breit und vertragen deshalb unterschiedlich viel.
  const SELECTOR = '.cart-items .quantity__input, .product-form__quantity .quantity__input';
  const KLICKRAUM = '.cart-items .quantity, .product-form__quantity .quantity';

  const fit = (input) => {
    const len = String(input.value || '').trim().length || 1;
    input.dataset.qtyLen = len;
  };

  const fitAll = () => document.querySelectorAll(SELECTOR).forEach(fit);

  // Waehrend des Tippens und nach dem Verlassen des Feldes.
  document.addEventListener('input', (event) => {
    if (event.target.matches(SELECTOR)) fit(event.target);
  });

  // Die Knoepfe − und + aendern den Wert per Skript; dabei faellt kein input-Ereignis,
  // auf das man sich verlassen koennte. Ein Klick im Warenkorb genuegt als Anlass,
  // alles neu zu vermessen.
  document.addEventListener('click', (event) => {
    if (event.target.closest(KLICKRAUM)) requestAnimationFrame(fitAll);
  });

  // ── Zeilensumme ──────────────────────────────────────────────────────────
  // Dieselbe Ueberlegung wie beim Mengenfeld: Die Preisspalte ist begrenzt, und
  // „1.234,56 €“ braucht dort deutlich mehr Platz als „4,49 €“. Gezaehlt werden nur die
  // ZIFFERN — Waehrungszeichen, Punkt und Komma sind schmal und unterschiedlich je
  // nach Sprache, die Ziffern sind das verlaessliche Mass.
  const PRICE_SELECTOR = '.cart-item__totals .price';

  const fitPrice = (el) => {
    const digits = (el.textContent.match(/\d/g) || []).length;
    el.dataset.priceDigits = digits;
  };

  const fitPrices = () => document.querySelectorAll(PRICE_SELECTOR).forEach(fitPrice);

  // Beobachtet wird der Warenkorb, wenn es ihn gibt — sonst das Dokument. Auf der
  // Produktseite tauscht Dawn beim Variantenwechsel den Kaufbereich aus; das Feld ist
  // danach ein neues Element und braucht sein Attribut erneut.
  const container = document.querySelector('.cart-items') || document.body;
  const fitEverything = () => {
    fitAll();
    fitPrices();
  };

  new MutationObserver(fitEverything).observe(container, { childList: true, subtree: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fitEverything);
  } else {
    fitEverything();
  }
})();
